// 报价
import request from '@/utils/request'

// /bizQuote/{id}
// 查询单个
export function queryById(id) {
  return request({
    url: '/bizQuote/' + id,
    method: 'get',
  })
}

// /bizQuote
// 添加
export function add(data) {
  return request({
    url: '/bizQuote',
    method: 'post',
    data
  })
}

//
// /bizQuote/{id}
// 删除
export function del(id) {
  return request({
    url: '/bizQuote/' + id,
    method: 'delete'
  })
}

// /bizQuote/deleteCustomerDetails/{id}
// 删除客户明细
export function delFormCustomer(id) {
  return request({
    url: '/bizQuote/deleteCustomerDetails/' + id,
    method: 'delete'
  })
}
// /bizQuote/deleteQuoteDetails/{id}
// 删除报价明细
export function delFormQuote(id) {
  return request({
    url: '/bizQuote/deleteQuoteDetails/' + id,
    method: 'delete'
  })
}

// /bizQuote
// 修改
export function edit(data) {
  return request({
    url: '/bizQuote',
    method: 'put',
    data
  })
}
